import { BindAll } from "lodash-decorators";
import { EnumAPI } from "../../apis";
import { BasesController } from "../bases";
import lodash from "lodash";
import { AjaxBasics, IAjaxConfig } from "../../helpers";

@BindAll()
export class ProductController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: "productId",
      infinite: true,
      pagination: EnumAPI.business_productSearch,
      details: EnumAPI.product_detail,
      paginationParams: {
        currentKey: "pageNo",
        pageSizeKey: "pageSize",
        response: {
          dataSource: "productList",
          total: "total",
          valueGetter: this.valueGetter,
        },
      },
    });
  }
  valueGetter(res) {
    const dataSource = lodash.map(lodash.get(res, "productList"), (item) => {
      return lodash.merge(item, {
        number: 1,
      });
    });
    return {
      dataSource,
    };
  }

  /**
   * 加载详情数据
   * @param body
   * @param AjaxConfig
   * @returns entity
   */
  async onFind(
    body?: string | number | { [key: string]: any },
    AjaxConfig?: IAjaxConfig
  ) {
    const res = await this.Details.onLoad(body, AjaxConfig);
    return this.onFindDetailSelect(res);
  }
  /**
   *
   * @param response
   * @returns
   */
  onFindDetailSelect(response) {
    lodash.assign(response, {
      // 轮播图
      _SwiperImgs: parsesSwiperImgs(response),
      // 渲染内容 图片
      _ContentImgs: parsesContentImgs(response),
      // 渲染内容
      _Content: parsesContent(response),
      // 参数配置
      _Configuration: parsesConfiguration(response),
      // 同系列产品
      _Series: parsesSeries(response),
      // 当前同系列产品
      _SerieFind: parsesSerieFind(response),
      // 绑定配件
      _FittingsBind: parsesFittings(response, 1),
      // 可选配件
      _FittingsOptional: parsesFittings(response, 0),
    });
    this.Details.Model.set(response);
    return this.Details.entity;
  }
}

/**
 * 解析 轮播图
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesSwiperImgs(entity) {
  return lodash.filter(
    lodash.get(
      entity,
      "productLabelsByCodeResponseVOList[0].productLabelsFiles",
      []
    ),
    ["fileType", 13]
  );
}
/**
 * 解析 渲染内容 图片
 * @param {*} response 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesContentImgs(response) {
  return lodash.filter(
    lodash.get(
      response,
      "productLabelsByCodeResponseVOList[0].productLabelsFiles"
    ),
    ["fileType", 32]
  );
}
/**
 * 解析 渲染内容
 * @param {*} response 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesContent(response) {
  return lodash.get(
    response,
    "productLabelsByCodeResponseVOList[0].productDetailHtmlMobile"
  );
}
/**
 * 解析 参数配置
 * @param {*} response 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesConfiguration(response) {
  return lodash.get(response, "configuration[0].configurationParameterList");
}
/**
 * 解析 同系列产品
 * @param {*} response 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesSeries(response) {
  return lodash.get(response, "recommentSpecProductList", []);
}
/**
 * 解析 当前系列 同系列产品
 * @param {*} response 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesSerieFind(response) {
  return (
    lodash.find(lodash.get(response, "recommentSpecProductList"), [
      "protocolProductId",
      response.agreementproductId,
    ]) || {}
  );
}
/**
 * 解析 配件
 * @param {*} response 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesFittings(response, optional: 0 | 1) {
  return lodash.filter(lodash.get(response, "productPartsVoList"), [
    "optional",
    optional,
  ]);
}
